import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import useAuth from '@hooks/useAuth';

const Login = () => {
    const { signUserIn } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async () => {
        try {
            const response = await signUserIn(email, password);

            if(!response?.success) {
                alert('Login fehlgeschlagen');
                return;
            };
        }catch (error: any) {
            console.error('Error logging in');
            alert(`Fehler: ${error.message}`)
        }
    }

    return (
        <Container className='my-5'>
            <Row>
                <Col xs={12} className='d-flex justify-content-center align-items-center'>
                    <img
                        src={require("@assets/logo/logo_main.png")}
                        alt='Logo'
                        width={200}
                        height={200}
                        className='object-fit-cover'
                    />
                </Col>
            </Row>
            <Row className='d-flex align-items-center justify-content-center flex-1 my-5'>
                <Col xs={12} xl={4}>
                    <Form style={{ background: '#b8cbca' }} className='p-5 rounded-2'>
                        <h1 className='mb-5 text-center'>Login</h1>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>E-mail</Form.Label>
                            <Form.Control
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                                placeholder="Enter email"
                                className='myBorder'
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Passwort</Form.Label>
                            <Form.Control
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type="password"
                                placeholder="Passwort"
                                className='myBorder'
                            />
                        </Form.Group>
                        <Button variant="primary" onClick={handleLogin}>
                            Submit
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default Login